import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { ParametrosService } from './parametros.service';
import { ConfiguracoesProjeto } from '../model/configuracoes-projeto.model';

  @Injectable()
  export class YoutubeService {

  private configuracao: ConfiguracoesProjeto;

  constructor(public http: HttpClient,
              private readonly parametrosService: ParametrosService) { 
                this.configuracao = this.parametrosService.getConfiguracao();
              }

    private get ChannelId() {
          return this.configuracao.youtube_channel_id;
    }

    private get PlaylistYoutubeId() {
      return this.configuracao.youtube_playlist_id;
    }

    private get TokenYoutube() {
      return this.configuracao.youtube_token;
    }

    private get ApiGoogleKey() {
      return this.configuracao.youtube_google_key;
    }

  getVideosForChanel(maxResults: string): Observable<Object> {
    let url = 'https://www.googleapis.com/youtube/v3/search?key=' + this.ApiGoogleKey + '&channelId=' + this.ChannelId + '&order=date&part=snippet &type=video,id&maxResults=' + maxResults
    return this.http.get(url)
      .pipe(map((res) => {
        return res;
      }))
  }

  getVideosForPlaylist(maxResults: string): Observable<Object> {
    
    let playlistUrl = 'https://youtube.googleapis.com/youtube/v3/playlistItems?part=snippet%2CcontentDetails&maxResults='+ maxResults + '&playlistId=' + this.PlaylistYoutubeId +'&key=' + this.TokenYoutube;
    return this.http.get(playlistUrl)
      .pipe(map((res) => {
        return res;
      }))
  }
}





// WEBPACK FOOTER //
// ./src/app/shared/service/youtube.service.ts